import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Components
import {
  Button
} from 'reactstrap';

class KeepEarningButton extends Component {

  static propTypes = {
    disabled: PropTypes.bool.isRequired,
    onClick: PropTypes.func,
  }

  static defaultProps = {
    onClick: () => {}
  }

  render() {
    const { disabled, onClick, children } = this.props;

    var modifierClassName = '';
    if (disabled)
      modifierClassName += ' KeepEarningButton_btn--disabled';

    return (
      <div>
        <div className="KeepEarningButton">
          <Button
            className={`KeepEarningButton_btn ${modifierClassName}`}
            onClick={onClick}
          >
            {children}
          </Button>
        </div>
      </div>
    );
  }
}

export default KeepEarningButton;



// WEBPACK FOOTER //
// ./src/pages/Account/components/LoyaltyButton/LoyaltyButton.js